import { defineNuxtPlugin, useRuntimeConfig, useHead } from '#app'

import { DEFAULT_BRAND_NAME, buildTitle } from '@baserow/modules/core/head'

/**
 * Applies the per-deployment brand name to the browser tab title.
 *
 * The `title`/`titleTemplate` in `core/head.js` are merged into Nuxt's static
 * `app.head` by `core/module.js`, which is resolved when the app is *built*. The
 * production image is built once and shared by several deployments (see
 * `web-frontend/Dockerfile`), so the name cannot be baked in and has to be
 * re-applied here, at runtime, from the public runtime config.
 *
 * A plugin-level `useHead` outranks the static `app.head` defaults, so this
 * replaces the default template rather than appending to it. It is still lower
 * priority than the page-level `useHead` calls that blank the template out for
 * publicly shared views (`database/pages/publicView.vue`,
 * `database/pages/form.vue`) and published builder apps
 * (`builder/components/PublicPageContent.vue`), so those keep rendering their
 * own bare titles with no product name appended.
 *
 * When the name is unset or equal to the default, nothing is registered at all,
 * so deployments that do not set `BASEROW_BRAND_NAME` keep the exact head
 * output they had before this plugin existed.
 */
export default defineNuxtPlugin(() => {
  const brandName = useRuntimeConfig().public.baserowBrandName

  if (!brandName || brandName === DEFAULT_BRAND_NAME) {
    return
  }

  useHead(buildTitle(brandName))
})
